import apiService from "../common/utils/apiService";
import * as exportActions from "../slices/exportSlice";

const EXPORT_URL = `/exports`;

/* To communicate with EXPORT SERVER */

export const exportOrder = (exportParams, successCallBack) => async (dispatch) => {
    dispatch(exportActions.exportOrderRequest());
    try {
      let url = EXPORT_URL;
      const response = await apiService.post(url, exportParams, {});
      dispatch(exportActions.exportOrderSuccess(response));
      if (successCallBack) {
        successCallBack();
      }
    } catch (error) {
      dispatch(exportActions.exportOrderFailure());
      console.error('Error creating order:', error);
    }
  }
  
  export const getExports = () => async (dispatch) => {
    dispatch(exportActions.getExportsDataRequest());
    try {
      let url = EXPORT_URL;
      const response = await apiService.get(url, null, {});
      dispatch(exportActions.getExportsDataSuccess(response));
    } catch (error) {
      dispatch(exportActions.getExportsDataFailure());
      console.error('Error creating order:', error);
    }
  }